var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIn(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5673_9188)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.26001 7.7301C6.59001 4.1501 7.93001 2.8501 13.26 2.8501C20.36 2.8501 20.36 5.1601 20.36 12.1001C20.36 19.0401 20.36 21.3501 13.26 21.3501",
    stroke: "#18AF69",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.03 8.88005C11.0186 8.88005 11.82 8.07864 11.82 7.09005C11.82 6.10146 11.0186 5.30005 10.03 5.30005C9.0414 5.30005 8.23999 6.10146 8.23999 7.09005C8.23999 8.07864 9.0414 8.88005 10.03 8.88005Z",
    fill: "#18AF69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.8 10.81L9.31 15.09L10.48 16.16C10.8259 16.4791 11.0339 16.9202 11.06 17.39L11.22 20.63C11.2282 20.8575 11.147 21.0791 10.9937 21.2474C10.8404 21.4156 10.6272 21.5171 10.4 21.53C10.1742 21.5384 9.95395 21.4585 9.78597 21.3073C9.61799 21.1561 9.51543 20.9455 9.5 20.72L9.34 17.93C9.33712 17.7778 9.30378 17.6277 9.24195 17.4886C9.18012 17.3495 9.09105 17.2242 8.98 17.12L7.3 15.76C7.1239 15.6032 6.98963 15.405 6.90932 15.1832C6.82902 14.9615 6.80519 14.7233 6.84 14.49L7.21 11.86L6.89 12.02L6.11 14.6C6.0474 14.8037 5.90803 14.9749 5.72138 15.0776C5.53474 15.1802 5.31547 15.2062 5.11 15.15C4.99474 15.1192 4.88737 15.0641 4.79505 14.9885C4.70273 14.9129 4.62758 14.8185 4.5746 14.7116C4.52161 14.6047 4.49202 14.4877 4.48777 14.3685C4.48353 14.2492 4.50475 14.1305 4.55 14.02L5.55 11.25C5.66762 10.9574 5.89315 10.7211 6.18 10.59L8.7 9.55005L9.04 9.65005C9.28163 9.72514 9.4896 9.88195 9.62827 10.0936C9.76693 10.3052 9.82765 10.5585 9.8 10.81Z",
    fill: "#18AF69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91998 15.76L8.29998 17.02L7.17998 20.92C7.15318 21.0245 7.10603 21.1226 7.04124 21.2089C6.97644 21.2951 6.89528 21.3677 6.80239 21.4225C6.7095 21.4773 6.60671 21.5132 6.4999 21.5282C6.3931 21.5433 6.28438 21.5371 6.17998 21.51C6.06585 21.487 5.95774 21.4405 5.86253 21.3735C5.76731 21.3065 5.68707 21.2204 5.62689 21.1207C5.56671 21.0211 5.52791 20.91 5.51294 20.7945C5.49798 20.679 5.50719 20.5617 5.53998 20.45L6.91998 15.76Z",
    fill: "#18AF69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.06 11.52L9.84998 13.3L11.16 14.5C11.2252 14.5665 11.3029 14.6194 11.3888 14.6555C11.4747 14.6915 11.5668 14.7101 11.66 14.7101C11.7531 14.7101 11.8453 14.6915 11.9312 14.6555C12.017 14.6194 12.0948 14.5665 12.16 14.5H12.21C12.2777 14.4356 12.3317 14.358 12.3686 14.2721C12.4055 14.1861 12.4245 14.0935 12.4245 14C12.4245 13.9065 12.4055 13.8139 12.3686 13.728C12.3317 13.642 12.2777 13.5645 12.21 13.5L10.06 11.52Z",
    fill: "#18AF69"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.87 12.77H17.06",
    stroke: "#18AF69",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.66 10.3799L17.96 12.6799L15.62 15.0199",
    stroke: "#18AF69",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5673_9188"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIn);
export default __webpack_public_path__ + "static/media/in.e19c7163cb4189d022626bb7ad16328b.svg";
export { ForwardRef as ReactComponent };